// extracted by mini-css-extract-plugin
export default {"searchItem":"profileBox_searchItem__sDmA+","searchItemVozDada":"profileBox_searchItemVozDada__EQVC-","srchTitleWraper":"profileBox_srchTitleWraper__TSWmP"};